import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=d13f7b98&"
import script from "./ViewFile.vue?vue&type=script&lang=js&"
export * from "./ViewFile.vue?vue&type=script&lang=js&"
import style0 from "./ViewFile.vue?vue&type=style&index=0&id=d13f7b98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports